import { ReorderListItem } from '@shared/components/reorder-list/reorder-list.interfaces';
import { FolderPickerSelection, IFolder } from '@modules/management/modules/folders/model/folders.interfaces';
import { IProperty, PropertyDefaultValue, PropertySubject } from '@services/property/property-model.interfaces';

export interface PropertyPickerConfig {
  type: PropertySubject;
  selectedList?: SelectedListConfig;
  viewTree?: ViewTreeConfig;
}

export interface SelectedListConfig {
  title?: string;
  inheritedListTitle?: string;
  draggable?: boolean;
  columns?: ListColumn[];
}

export enum ListColumn {
  TrackState,
  Hidden,
  DefaultValue,
  Required,
  PropertyName,
  FullPropertyName
}

export interface ViewTreeConfig {
  multiselect?: boolean;
  disableParentSelection?: boolean;
  filter?(property: IProperty): boolean;
}

export interface HealthRelated {
  healthRelated?: number;
}

export interface ReorderPickerProperty extends IProperty, ReorderListItem {}
export interface ReorderPickerFolder extends IFolder, HealthRelated, ReorderListItem {}

export type ReorderPickerItem = ReorderPickerProperty | ReorderPickerFolder;

export interface PropertyPickerSelection extends FolderPickerSelection {
  propertyFolderID?: number;
  healthRelated?: number;
  propertyID?: number;
  hidden?: boolean;
  defaultValue?: PropertyDefaultValue;
}

export interface SelectedProperty extends HealthRelated {
  propertyID?: number;
  propertyFolderID?: number;
  hidden?: boolean;
  required?: number;
  defaultValue?: PropertyDefaultValue;
}
